import React from 'react';

function Layout({ children }) {
  return <div className="flex flex-col bg-white-bright sm:h-screen" style={{ flex: 1, minHeight: "100vh" }}>{children}</div>;
}

export default Layout;
